import { container } from "assets/jss/material-kit-pro-react.jsx";

const carouselStyle = {
  section: {
    padding: "70px 0"
  },
  container,
  marginAuto: {
    marginLeft: "auto !important",
    marginRight: "auto !important"
  }
};

export default carouselStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.jsx